import { useCallback } from 'react';

import type { CustomizationHistoryEntry } from './useCustomization';
import { useCustomization } from './useCustomization';

export interface UseUndoRedoProps {}

export const useUndoRedo = (): {
  canUndo: boolean;
  canRedo: boolean;
  undo: () => void;
  redo: () => void;
  next: CustomizationHistoryEntry | undefined;
  previous: CustomizationHistoryEntry | undefined;
} => {
  const { history } = useCustomization();

  return {
    canUndo: history.activeIndex > 0,
    canRedo: history.activeIndex < history.entries.length - 1,
    undo: useCallback(() => {
      if (history.activeIndex === 0) return;

      history.select(history.activeIndex - 1);
    }, [history]),
    redo: useCallback(() => {
      if (history.activeIndex === history.entries.length - 1) return;

      history.select(history.activeIndex + 1);
    }, [history]),
    next: history.entries[history.activeIndex + 1],
    previous: history.entries[history.activeIndex - 1],
  };
};
